var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.92 58.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{mix-blend-mode:multiply;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#6a2f38;}.cls-7{fill:#d4ad89;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-497.48 -426.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 841.89,
    height: 595.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-497.48 -426.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 613.9,
    y: 425.59,
    width: 76.5,
    height: 59.61
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "174.29 30.42 181.2 37.33 171.64 46.89 160.03 35.29 154.67 40.65 171.64 57.61 191.92 37.33 179.65 25.06 174.29 30.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.47 30.86 164.8 10.21 154.59 0 144.23 10.37 154.47 30.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "161.05 34.11 174.88 20.28 170.27 15.68 161.05 34.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "138.75 15.84 134.31 20.28 147.65 33.63 138.75 15.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 648.39,
    y: 473.25,
    width: 7.47,
    height: 7.47,
    transform: "translate(-643.76 174.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "132.42 41.61 128.14 37.33 135.06 30.4 129.7 25.04 117.42 37.33 127.06 46.97 132.42 41.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "149.31 35.29 140.6 44 140.6 44 132.34 52.25 137.7 57.61 154.67 40.64 149.31 35.29"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M522.83,464.9H499.5V450.72h3.78V461h16.19c0-.95.07-2.16-.4-2.54a3.6,3.6,0,0,0-2.18-.55,6.1,6.1,0,0,1-2.45-.28,4.67,4.67,0,0,1-2-1.44c-.34-.57-.58-1-.73-1.31a7.82,7.82,0,0,1-.42-1.23A14.76,14.76,0,0,1,511,451V438.64a7.29,7.29,0,0,1,1.45-3.54,3.48,3.48,0,0,1,2.16-1.08h4a3.66,3.66,0,0,1,2.92,1.6,6.12,6.12,0,0,1,.93,1.62,5,5,0,0,1,.3,1.76v11.62h-3.78V440.48a2.14,2.14,0,0,0-2.12-2.17h0a2.14,2.14,0,0,0-2.12,2.17v11.11a1.67,1.67,0,0,0,.14.34c0,.1.12.23.22.41a2.65,2.65,0,0,0,1.37,1,11.29,11.29,0,0,0,3,.26h0a2.86,2.86,0,0,1,2.78,2.29,24,24,0,0,1,.46,2.52Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.84,461H563.5l0-11.67a1.69,1.69,0,1,1,3.37,0Zm-24.9,0-4.29,0V448.59a2.15,2.15,0,1,1,4.3,0Zm39.32-26.85a10.07,10.07,0,0,1,.86.79c.64.78,1.28,1.57,1.88,2.38V461H570.62v-11.2a5.13,5.13,0,0,0-1.3-3.91,5.93,5.93,0,0,0-1.33-1,5.64,5.64,0,0,0-1.46-.69,4.41,4.41,0,0,0-2.93,0,5.84,5.84,0,0,0-2.39,1.75,6.36,6.36,0,0,0-1.5,3.72v8.77l2.21,2.58H545.72l.33-15.16a3.25,3.25,0,0,0-3.21-3.36h-4.62a4.41,4.41,0,0,0-4.36,4.47v17.93h8.08v6.91h3.78V464.9h42.07v-27a6,6,0,0,1,1.48-2.38c.33-.35.7-.66,1-1,.1-.09.17-.21.29-.34Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M594.72,470.16c-.4.44-.82.84-1.23,1.26-.09.09-.17.2-.3.35h9.93c-.3-.29-.55-.49-.74-.72-.66-.81-1.34-1.6-1.92-2.46a2.24,2.24,0,0,1-.33-1.15h0c0-9.92,0-17.78,0-27.7a5.53,5.53,0,0,1,1.46-4c.39-.43.82-.83,1.23-1.25.09-.1.17-.21.3-.35h-9.93a8.64,8.64,0,0,1,.74.72c.66.81,1.33,1.6,1.92,2.46a2.29,2.29,0,0,1,.34,1.24v4.62c0,9.55,0,13.27,0,21.93v1.14a5.5,5.5,0,0,1-1.45,3.87",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M527.68,450.7v15.16a2.06,2.06,0,0,1-2,2.08h-1.9v3.87h5.7a2,2,0,0,0,2-2.05V450.7Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M526.22,449.19c.51.6,1,1.2,1.5,1.85a1.71,1.71,0,0,1,.26.93v.42h3.09a4,4,0,0,1,1.12-2.54c.31-.32.64-.62,1-.94.07-.07.14-.16.23-.27h-7.74c.23.22.42.37.58.55",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M498.06,449.19c.51.6,1,1.2,1.5,1.85a1.71,1.71,0,0,1,.26.93v.42h3.09a4,4,0,0,1,1.13-2.54c.3-.32.63-.62.95-.94.07-.07.14-.16.23-.27h-7.74c.23.22.43.37.58.55",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "7.03 43.28 4.52 45.85 2.02 43.28 4.52 40.71 7.03 43.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.26 43.28 9.76 45.85 7.25 43.28 9.76 40.71 12.26 43.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.03 43.28 82.53 45.85 80.02 43.28 82.53 40.71 85.03 43.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "70.18 10.37 67.68 12.94 65.17 10.37 67.68 7.8 70.18 10.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "90.27 43.28 87.76 45.85 85.26 43.28 87.76 40.71 90.27 43.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.39,478.44a.43.43,0,0,1,0,.86.37.37,0,0,1-.29-.13.44.44,0,0,1,0-.6.37.37,0,0,1,.29-.13m-1,0a.37.37,0,0,1,.29.13.44.44,0,0,1,0,.6.37.37,0,0,1-.29.13.38.38,0,0,1-.3-.13.44.44,0,0,1,0-.6.38.38,0,0,1,.3-.13m4,.23v3.18a.88.88,0,0,1-.18.54.74.74,0,0,1-.58.28h-4.85a1.21,1.21,0,0,1-.85-.33,1.4,1.4,0,0,1-.48-1.1V479.6l.36-.3h.36v1.94a.78.78,0,0,0,.24.57.75.75,0,0,0,.57.24h4.37c.21,0,.32-.1.32-.33v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "9.03 49.86 9.03 56.3 9.39 56.3 9.75 56 9.75 49.86 9.03 49.86"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M510.05,478.67v3.92a2.08,2.08,0,0,1-.54,1.52,2,2,0,0,1-1.12.58,3.61,3.61,0,0,1-.59.05h-.39l-.28-.35v-.28a4.33,4.33,0,0,0,.53,0c1.11,0,1.67-.52,1.67-1.56v-3.9Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M511.77,476.45v5.27a.31.31,0,0,0,.33.33h.11v.62h-.39a.72.72,0,0,1-.48-.18.82.82,0,0,1-.29-.64v-5.4Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 14.67,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.18,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 17.68,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.37,476.76a.37.37,0,0,1,.29.13.41.41,0,0,1,.12.3.45.45,0,0,1-.12.31.41.41,0,0,1-.58,0,.42.42,0,0,1-.13-.31.38.38,0,0,1,.13-.3.37.37,0,0,1,.29-.13m-.52-.83a.4.4,0,0,1,.29.12.44.44,0,0,1,.11.29.41.41,0,0,1-.11.28.37.37,0,0,1-.29.13.35.35,0,0,1-.28-.13.38.38,0,0,1-.12-.28.4.4,0,0,1,.12-.29.38.38,0,0,1,.28-.12m-.51.83a.36.36,0,0,1,.29.13.38.38,0,0,1,.13.3.42.42,0,0,1-.13.31.38.38,0,0,1-.29.12.41.41,0,0,1-.3-.12.45.45,0,0,1-.12-.31.41.41,0,0,1,.12-.3.38.38,0,0,1,.3-.13m3.39,1.91v3.18a1.23,1.23,0,0,1,0,.2h.45v.62h-.33l-.24-.3h0a.72.72,0,0,1-.59.3H522.3l-.24-.3h0a.74.74,0,0,1-.6.3h-1.67l-.23-.3h0a.72.72,0,0,1-.59.3h-2.25v-.62h2c.21,0,.32-.1.32-.33v-2.05h.72v2.18a.65.65,0,0,1,0,.2h1.5a.29.29,0,0,0,.33-.33v-2.55h.72v2.68a.64.64,0,0,1,0,.2h1.51c.21,0,.32-.1.32-.33v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.62,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M528.51,476.76a.39.39,0,0,1,.3.13.41.41,0,0,1,.12.3.45.45,0,0,1-.12.31.42.42,0,0,1-.3.12.41.41,0,0,1-.3-.12.45.45,0,0,1-.12-.31.41.41,0,0,1,.12-.3.38.38,0,0,1,.3-.13m-1,0a.38.38,0,0,1,.3.13.4.4,0,0,1,.11.3.44.44,0,0,1-.11.31.41.41,0,0,1-.3.12.4.4,0,0,1-.29-.12.46.46,0,0,1-.13-.31.42.42,0,0,1,.13-.3.37.37,0,0,1,.29-.13m1.37,1.91v3.18a1.23,1.23,0,0,1,0,.2h.45v.62H529l-.25-.3h0a.71.71,0,0,1-.59.3h-1.47v-.62h1.2A.29.29,0,0,0,528,482a.33.33,0,0,0,.1-.25v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.74,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 33.25,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 34.75,
    y: 55.47,
    width: 4.05,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38.75,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M545.8,478.67v3.18a.83.83,0,0,1-.23.58.71.71,0,0,1-.54.24H543.4l-.27-.3h0a.72.72,0,0,1-.59.3h-1.63l-.28-.3h0a.74.74,0,0,1-.6.3h-2.24v-.62h2a.29.29,0,0,0,.33-.33v-2.05h.72v2.18a1.23,1.23,0,0,1,0,.2h1.5c.21,0,.32-.1.32-.33v-2.55h.72v2.68a1.23,1.23,0,0,1,0,.2h1.5a.29.29,0,0,0,.33-.33v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M551.44,476.45v5.4a.82.82,0,0,1-.18.52.71.71,0,0,1-.59.3H547l-.3-.37v-.25h2.27l-1.46-4.53h.72l1.47,4.53h.73a.28.28,0,0,0,.24-.11.32.32,0,0,0,.07-.22v-5.27Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "55.13 49.86 55.13 56.3 55.49 56.3 55.85 56 55.85 49.86 55.13 49.86"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M557.23,480.15a1,1,0,0,0-.37-.81.91.91,0,0,0-.54-.14,1.1,1.1,0,0,0-.89.39,1.62,1.62,0,0,0-.33,1.08,1.45,1.45,0,0,0,.38,1.05,1.16,1.16,0,0,0,.88.35,2.41,2.41,0,0,0,.87-.15Zm0,2.43a2.59,2.59,0,0,1-.92.17,1.76,1.76,0,0,1-1.45-.66,2.26,2.26,0,0,1-.48-1.49,2.1,2.1,0,0,1,.5-1.46,1.89,1.89,0,0,1,1.44-.57,1.69,1.69,0,0,1,1.12.36,1.47,1.47,0,0,1,.52,1.22v2.44a2.07,2.07,0,0,1-.71,1.68,2.2,2.2,0,0,1-.86.4,3.11,3.11,0,0,1-.69.07h-.39l-.28-.36v-.27a4.63,4.63,0,0,0,.54,0c1.1,0,1.65-.51,1.66-1.55",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M564,483.58a.41.41,0,0,1,.3.12.44.44,0,0,1,.12.3.43.43,0,0,1-.12.31.41.41,0,0,1-.6,0,.43.43,0,0,1-.12-.31.44.44,0,0,1,.12-.3.41.41,0,0,1,.3-.12m3.47-4.91v3.18a.64.64,0,0,1,0,.2h.46v.62h-.3l-.28-.3h0a.73.73,0,0,1-.59.3H561.9a1.24,1.24,0,0,1-.84-.32,1.38,1.38,0,0,1-.49-1.11V479.6l.36-.3h.36v1.94a.81.81,0,0,0,.23.57.8.8,0,0,0,.58.24h4.37a.33.33,0,0,0,.24-.1.34.34,0,0,0,.08-.23v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 70.4,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 71.9,
    y: 55.47,
    width: 2.81,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 74.66,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 76.16,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 77.67,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578.41,483.58a.38.38,0,0,1,.29.12.44.44,0,0,1,.12.3.43.43,0,0,1-.12.31.39.39,0,0,1-.29.13A.43.43,0,0,1,578,484a.44.44,0,0,1,.12-.3.42.42,0,0,1,.3-.12m-1,0a.4.4,0,0,1,.29.12.41.41,0,0,1,.13.3.4.4,0,0,1-.13.31.41.41,0,0,1-.29.13.42.42,0,0,1-.3-.13A.43.43,0,0,1,577,484a.44.44,0,0,1,.12-.3.41.41,0,0,1,.3-.12m1.53-4.91v3.18a.79.79,0,0,1-.21.55.71.71,0,0,1-.56.27h-1.48v-.62h1.2a.3.3,0,0,0,.24-.1.3.3,0,0,0,.09-.23v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M582.31,478.67v3.92a2.08,2.08,0,0,1-.54,1.52,2,2,0,0,1-1.12.58,3.61,3.61,0,0,1-.59.05h-.39l-.28-.35v-.28a4.33,4.33,0,0,0,.53,0c1.11,0,1.66-.52,1.66-1.56v-3.9Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M584.09,478.62a4.4,4.4,0,0,1,.65-.05,2.06,2.06,0,0,1,1.52.58,1.92,1.92,0,0,1,.51,1.37v1.33a.65.65,0,0,1,0,.2H587v.62h-.13l-.23-.3h0a.54.54,0,0,1-.15.15.73.73,0,0,1-.44.15h-2.78v-.62h2.51c.21,0,.31-.1.31-.33v-1.1a1.48,1.48,0,0,0-.36-1,1.61,1.61,0,0,0-1.21-.43,2.13,2.13,0,0,0-.39,0Z",
    transform: "translate(-497.48 -426.59)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.44,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.95,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 92.46,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.97,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 95.48,
    y: 55.47,
    width: 1.57,
    height: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M596.37,476.76a.39.39,0,0,1,.3.13.41.41,0,0,1,.12.3.45.45,0,0,1-.12.31.44.44,0,0,1-.6,0,.45.45,0,0,1-.12-.31.41.41,0,0,1,.12-.3.39.39,0,0,1,.3-.13m-1,0a.38.38,0,0,1,.3.13.41.41,0,0,1,.12.3.45.45,0,0,1-.12.31.41.41,0,0,1-.3.12.4.4,0,0,1-.29-.12.46.46,0,0,1-.13-.31.42.42,0,0,1,.13-.3.37.37,0,0,1,.29-.13m1.37,1.91v3.18a1.23,1.23,0,0,1,0,.2h.45v.62h-.33l-.25-.3h0a.74.74,0,0,1-.6.3h-1.47v-.62h1.2a.29.29,0,0,0,.22-.08.33.33,0,0,0,.1-.25v-3.05Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M599.32,476.45v5.4a1.36,1.36,0,0,1,0,.2h.45v.62h-.3l-.28-.3h0a.71.71,0,0,1-.59.3h-1.47v-.62h1.2a.28.28,0,0,0,.25-.13.27.27,0,0,0,.07-.2v-5.27Z",
    transform: "translate(-497.48 -426.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601.93,476.45v5.4a.8.8,0,0,1-.22.57.7.7,0,0,1-.55.25h-1.47v-.62h1.2a.28.28,0,0,0,.25-.11.32.32,0,0,0,.07-.22v-5.27Z",
    transform: "translate(-497.48 -426.59)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f4f96956a7efc0f76392e0511053be9.svg";
export { ForwardRef as ReactComponent };